import gql from 'graphql-tag';

import { ACTIVITY_FRAGMENT } from '../fragments';
import { ERROR_FRAGMENT } from '../fragments';

const mutationName = 'createActivity';

export const CREATE_ACTIVITY = {
  mutationName,
  mutationBody: gql`
    mutation ${mutationName}(
      $input: CreateActivityMutationInput!
    ) {
      ${mutationName}(
        input: $input
      ) {
        activity {
          ...activity
        }
        errors {
          ...errors
        }
      }
    }
    ${ACTIVITY_FRAGMENT}
    ${ERROR_FRAGMENT}
  `,
};
